<template>
  <div class="md-layout"></div>
</template>
<script>
import { handleUserDetails } from "../utils/auth0";
import api from "@/api";

export default {
  data() {
    return {
      config: api.props.config
    };
  },
  mounted() {
    this.$nextTick(() => {
      handleUserDetails().then((url) => {
        //do we want to be able to redirect them back to the page they tried to land on?
        window.location.replace(url);
      });
    });
  }
};
</script>
